import Controller from './Controller';
import type Report from '../checks/Report';
import { Combined_CreateState } from '../commands/combined';
import type { IModelVersion } from './Controller';
import type { Position, StateType } from '../commands/types';

/**
 * Controller to add a new state to an FSM
 */
export default class AddStateController extends Controller {
  objectTypeId: string;
  fsmId: string;

  constructor(modelVersion: IModelVersion, objectTypeId: string, fsmId: string) {
    super(modelVersion);
    this.objectTypeId = objectTypeId;
    this.fsmId = fsmId;
  }

  /**
   * Add a new state.
   *
   * @param {String} name The name for the new state.
   * @param {String} type The type for the new state.
   * @param {Object} position The position.
   */
  addState = async (name: string, type: StateType, position?: Position): Promise<Report> => {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_CreateState(
        model,
        this.objectTypeId,
        this.fsmId,
        name,
        type,
        position
      );
      return checks;
    });
  };
}
